import { Database } from "@vuex-orm/core";

import User from "./models/User.js";

import Building from "./models/Building.js";
import BuildingLot from "./models/BuildingLot.js";
import BuildingOwner from "./models/BuildingOwner.js";
import MeetingGuest from "./models/MeetingGuest.js";
import Contact from "./models/Contact.js";
import Majority from "./models/Majority.js";
import Mandate from "./models/Mandate.js";
import Media from "./models/Media.js";
import Meeting from "./models/Meeting.js";
import Resolution from "./models/Resolution.js";
import ResolutionCatalog from "./models/ResolutionCatalog.js";
import Tag from "./models/Tag.js";
import VotingCategory from "./models/VotingCategory.js";
import BuildingOwnerVotingRight from "./models/BuildingOwnerVotingRight";
import Configuration from "./models/Configuration";
import Recipient from "./models/Recipient";
import RecipientMeetingDoc from "./models/RecipientMeetingDoc";
import MeetingCorrespondenceVote from "./models/MeetingCorrespondenceVote";
import Invoice from "./models/Invoice";
import BuildingMajorities from "./models/BuildingMajorities.js";
import MeetingRegister from "./models/MeetingRegister";
import Docage from "./models/Docage";

import TableHeader from "./models/TableHeader.js";

// pivots..
import ResolutionCatalogTag from "./models/ResolutionCatalogTag";
import MeetingResolution from "./models/MeetingResolution";
import ResolutionVote from "./models/ResolutionVote";
import BuildingOwnerBuildingLot from "./models/BuildingOwnerBuildingLot";

// vuex modules
import mandates from "../vuex/modules/mandates";
import resolutionVotes from "../vuex/modules/resolution-votes";
import buildingOwners from "../vuex/modules/building-owners";
import contacts from "../vuex/modules/contacts";
import meetingResolutions from "../vuex/modules/meeting-resolutions";
import votingCategories from "../vuex/modules/voting-categories";
import majorities from "../vuex/modules/majorities";
import meetings from "../vuex/modules/meetings";
import buildings from "../vuex/modules/buildings";
import media from "../vuex/modules/media";
import meetingCorrespondenceVotes from "../vuex/modules/meeting-correspondence-votes.js";

const database = new Database();

database.register(User);

database.register(Building, buildings);
database.register(BuildingLot);
database.register(BuildingOwner, buildingOwners);
database.register(MeetingGuest);
database.register(Contact, contacts);
database.register(Majority, majorities);
database.register(Mandate, mandates);
database.register(Media, media);
database.register(Meeting, meetings);
database.register(Resolution);
database.register(ResolutionCatalog);
database.register(Tag);
database.register(VotingCategory, votingCategories);
database.register(BuildingOwnerVotingRight);
database.register(Configuration);
database.register(Recipient);
database.register(RecipientMeetingDoc);
database.register(MeetingCorrespondenceVote, meetingCorrespondenceVotes);
database.register(Invoice);
database.register(BuildingMajorities);
database.register(MeetingRegister);
database.register(Docage);

database.register(TableHeader);

// EX: many-to-many pivot table
database.register(ResolutionCatalogTag);
database.register(MeetingResolution, meetingResolutions);
database.register(ResolutionVote, resolutionVotes);
database.register(BuildingOwnerBuildingLot);

export default database;
